import React from "react";
import moment from "moment";

import { fetchApi } from "../../Network/NetworkService";
import { notif } from "../Ui/Notification";

import "../../Assets/Pages/dermatoSdr.css";
import IconTooltip from "../Ui/IconTooltip";

class DermatoSdrHistory extends React.Component {
  constructor() {
    super();
    this.state = {
      history: [],
      loading: false,
      loaded: false,
      page: 1,
      totalPage: 0,
      countItems: 0,
    };
  }

  componentDidMount() {
    this.fetchHistory();
  }

  fetchHistory = () => {
    this.setState({ loading: true });
    fetchApi("/dermato-sdr/history?page=" + this.state.page)
      .then((res) => {
        this.setState({
          history: res.history || [],
          totalPage: res.countPages || 0,
          countItems: res.countItems || 0,
          loaded: true,
          loading: false,
        });
      })
      .catch(() => {
        notif.addNotification(
          "Erreur",
          "Erreur de récupération de l'historique",
          "warning",
        );
        this.setState({ loading: false });
      });
  };

  updatePage(page) {
    this.setState({ history: [], page, loading: true }, this.fetchHistory);
  }

  render() {
    const { history, loading, loaded, page, totalPage, countItems } =
      this.state;

    return (
      <div className="dermato-sdr-container">
        <div className="dermato-sdr-header">
          <h2 className="dermato-sdr-title">{"Historique Dermato SDR"}</h2>
          <button
            className="dermato-sdr-btn dermatosdr-btn-link"
            onClick={() => this.props.history.push("/dermato-sdr")}
          >
            {"← Retour aux envois"}
          </button>
        </div>

        <div className="dermato-sdr-card">
          <h3 className="dermato-sdr-card-title">
            {"Campagnes"} ({countItems})
          </h3>

          {loading ? (
            <div className="dermato-sdr-empty">
              <span className="loader" />
            </div>
          ) : loaded && history.length === 0 ? (
            <div className="dermato-sdr-empty">{"Aucune campagne."}</div>
          ) : history.length > 0 ? (
            <div>
              <table className="dermato-sdr-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Type</th>
                    <th>{"Date ciblée"}</th>
                    <th>Destinataires</th>
                    <th>{"Envoyés"}</th>
                    <th>{"Échecs"}</th>
                    <th>{"Marquage KO"}</th>
                  </tr>
                </thead>
                <tbody>
                  {history.map((h) => (
                    <tr key={h._id}>
                      <td>{moment(h.createdAt).format("DD/MM/YYYY HH:mm")}</td>
                      <td>
                        <span
                          className={
                            "dermato-sdr-badge " +
                            (h.type === "relance"
                              ? "dermato-sdr-badge-relance"
                              : "dermato-sdr-badge-send")
                          }
                        >
                          {h.type === "relance" ? "Relance" : "Suivi"}
                        </span>
                      </td>
                      <td>{h.campaignDate || "—"}</td>
                      <td>{h.recipientCount}</td>
                      <td style={{ color: "#2e7d32", fontWeight: 600 }}>
                        {h.sentCount}
                      </td>
                      <td
                        style={{
                          color: h.failCount > 0 ? "#c62828" : "#888",
                          fontWeight: h.failCount > 0 ? 600 : 400,
                        }}
                        title={(h.failures || []).join(", ")}
                      >
                        {h.failCount}
                      </td>
                      {/* Emails délivrés mais dont le marquage en base a
                          échoué : l'utilisateur peut être re-sélectionné par
                          une prochaine campagne. */}
                      <td
                        style={{
                          color:
                            (h.flagFailures || []).length > 0
                              ? "#e65100"
                              : "#888",
                          fontWeight:
                            (h.flagFailures || []).length > 0 ? 600 : 400,
                        }}
                        title={(h.flagFailures || []).join(", ")}
                      >
                        {(h.flagFailures || []).length}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="dermatosdr-pagination">
                <p style={{ margin: 0, color: "#888", fontSize: 14 }}>
                  Page <strong>{page}</strong> / {totalPage}
                </p>
                <div>
                  {page > 1 && (
                    <IconTooltip
                      icon="fa fa-chevron-left"
                      text="Page précédente"
                      onClick={() => this.updatePage(page - 1)}
                    />
                  )}
                  {page < totalPage && (
                    <IconTooltip
                      icon="fa fa-chevron-right"
                      text="Page suivante"
                      onClick={() => this.updatePage(page + 1)}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default DermatoSdrHistory;
